import styled from 'styled-components'
import Link from '../../../../utils/Link'

const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  display: -ms-flexbox;
  -ms-flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 17px;
`

const AddressInboxLink = styled(Link)`
  display: block;
  width: 100%;
  color: #333;
  font-weight: bold;
`

const DivThemeColor = styled.div`
  color: ${props => props.theme.email.full.color};
`

export { Header, AddressInboxLink, DivThemeColor }
